import { CreateElement, VNode, VNodeData } from 'vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ClList extends Vue {
  @Prop({
    type: String,
    default: 'ul'
  })
  public component!: string;

  @Prop({
    type: Boolean,
    default: false
  })
  public dense!: boolean;

  @Prop({
    type: Boolean,
    default: false
  })
  public disablePadding!: boolean;

  public render(h: CreateElement): VNode {
    const data: VNodeData = {
      class: {
        'cl-list': true,
        'cl-list--dense': this.dense,
        'cl-list--padding': !this.disablePadding
      },
      on: {
        keydown: (event: KeyboardEvent) => {
          this.$emit('keydown', event);
        }
      }
    };
    return h(this.component, data, [
      this.$slots.subheader,
      this.$slots.default
    ]);
  }
}
